import { optimisticDispatch } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  setDescription
} from '../redux/blockers'

type Payload = {
  blockerId: number
  description?: any
}

const requestChangeBlockerDescription = ({
  blockerId,
  description,
}: Payload) => async dispatch => {
  const optimisticAction = optimisticDispatch(dispatch, setDescription({
    blockerId,
    description,
  }))

  try {
    await apiAction('ChangeBlockerDescription', {
      id: blockerId,
      rtDescription: description,
    })
  } finally {
    optimisticAction.revert()
  }
}

export default requestChangeBlockerDescription
